import { motion } from "framer-motion";

export const Footer = () => {
  return <>
      {/* Main Footer */}
      <motion.footer initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} transition={{
      duration: 0.6
    }} viewport={{
      once: true
    }} className="py-16 px-4 border-t border-border">
      <div className="max-w-6xl mx-auto">
        <div className="text-center space-y-6">
          <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} viewport={{
            once: true
          }} className="text-sm text-muted-foreground space-y-2">
            <p>© 2026 FixTheFormula.org</p>
            <p>
              In partnership with <a href="https://openlabelresearch.org" target="_blank" rel="noopener noreferrer" className="underline hover:no-underline">
                OpenLabel Research Foundation
              </a>
            </p>
          </motion.div>
        </div>
      </div>
      </motion.footer>
    </>;
};